import { useParams } from "react-router";
import { PACKAGE_ROUTE, PROJECTS_ROUTE, PROJECT_ROUTE } from "Constants";

const useProjectsRoute = (
  projectId?: string | null,
  packageId?: string | null,
): string => {
  const { groupId } = useParams();

  let route = groupId
    ? `/${PROJECTS_ROUTE}/group/${groupId}`
    : `/${PROJECTS_ROUTE}`;

  if (projectId) {
    route += `/${PROJECT_ROUTE}/${projectId}`;
  }

  if (packageId) {
    route += `/${PACKAGE_ROUTE}/${packageId}`;
  }

  return route;
};

export default useProjectsRoute;
